export default __webpack_public_path__ + "static/media/151-houses.dfe82fcf.png";